import {NgModule, ErrorHandler, Injectable, Injector} from '@angular/core';
import {NavigationError, Router, RouterModule, Routes} from '@angular/router';
import {RouterLinks} from "./enums/router-links";
import {ModulesListComponent} from "./pages/modules-list/modules-list.component";
import {ErrorComponent} from "./pages/error/error.component";
import {LoginComponent} from "./pages/login/login.component";
import {MyAccountComponent} from "./pages/my-account/my-account.component";
import {CreateAccountComponent} from "./pages/create-account/create-account.component";
import {QuestionComponent} from "./pages/question/question.component";
import {PasswordReminderComponent} from "./pages/password-reminder/password-reminder.component";
import {PasswordResetComponent} from "./pages/password-reset/password-reset.component";
import {ModuleIntroComponent} from "./pages/module-intro/module-intro.component";
import {ModuleExplanationComponent} from "./pages/module-explanation/module-explanation.component";
import {ModuleEndComponent} from "./pages/module-end/module-end.component";
import {AuthGuard} from "./helpers/auth-guard.helper";

const routes: Routes = [
  {path: RouterLinks.Error404, component: ErrorComponent},
  {path: RouterLinks.Login, component: LoginComponent},
  {path: RouterLinks.PasswordReminder, component: PasswordReminderComponent},
  {path: RouterLinks.PasswordReset, component: PasswordResetComponent},
  {path: RouterLinks.MyAccount, component: MyAccountComponent}, //canActivate: [AuthGuard]
  {path: RouterLinks.CreateAccount, component: CreateAccountComponent},
  {path: RouterLinks.ModulesList, component: ModulesListComponent}, //canActivate: [AuthGuard]
  {path: RouterLinks.ModuleIntro + '/:ref', component: ModuleIntroComponent}, //canActivate: [AuthGuard]
  {path: RouterLinks.Questions + '/:ref', component: QuestionComponent}, //canActivate: [AuthGuard]
  {path: RouterLinks.ModuleExplanation + '/:ref', component: ModuleExplanationComponent}, //canActivate: [AuthGuard]
  {path: RouterLinks.ModuleEnd + '/:ref', component: ModuleEndComponent}, //canActivate: [AuthGuard]
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private injector: Injector) {
    const router = this.injector.get(Router);

    router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        router.navigate(['/' + RouterLinks.Error404]);
      }
    });
  }
}
